export default __webpack_public_path__ + "static/media/the-album.215fdc48.jpg";